import { Box, Tooltip } from "@mui/material";
import { ReactNode } from "react";

type MarkerCorner = "top-left" | "top-right" | "bottom-left";

interface CornerOffset {
  top?: number;
  bottom?: number;
  left?: number;
  right?: number;
}

const CORNER_OFFSETS: Record<MarkerCorner, CornerOffset> = {
  "top-left": { top: 2, left: 2 },
  "top-right": { top: 2, right: 2 },
  "bottom-left": { bottom: 2, left: 2 },
};

interface Props {
  corner: MarkerCorner;
  color: string;
  tooltip: ReactNode;
  label?: string;
}

export const MarkerDot = ({ corner, color, tooltip, label }: Props) => (
  <Tooltip placement="top" title={tooltip}>
    <Box
      aria-label={label}
      sx={{
        position: "absolute",
        ...CORNER_OFFSETS[corner],
        width: 7,
        height: 7,
        borderRadius: "50%",
        bgcolor: color,
        cursor: "help",
      }}
    />
  </Tooltip>
);
